<template>
  <div>
    <leftSideBar :anchor="anchor"></leftSideBar>
    <SideBar></SideBar>
    <div class="page-box">
      <div class="secure-block">
        <h3 class="rescue-bigtitle"
            id="one">海外医疗找威马捷</h3>
        <h4 class="rescue-title">海外医疗为什么找威马捷</h4>
        <div class="inner-main">
          <p class="new-note">北京威马捷成立于2003年，主要提供国际医疗协调服务和国际医疗紧急救援服务。</p>
          <p class="new-note">作为日资企业，利用自身优势与日本各大国立医院、大学附属医院、著名私立医院以及小型专科医院和诊所建立了长期密切的合作关系。主要合作医院以东京、大阪、神户为中心，覆盖了北海道到九州的日本全国。同时北京威马捷也是德国海德堡大学医院、意大利圣拉斐尔科学研究医院、意大利圣多纳托科学研究医院、意大利盖氏骨科科学研究医院、新加坡伊丽莎白乌节路医院、新加坡伊丽莎白诺维娜医院、新加坡鹰阁医院、新加坡百汇东岸医院等官方指定合作机构，并与美国、中国香港等地的医疗集团展开合作。</p>
          <p class="new-note new-line">北京威马捷的年咨询量高达3000例以上，累积了大量的经验，可以根据每位客户需求，提供定制方案。</p>
          <p class="new-note">北京威马捷是日本威马捷救援株式会社（EAJ）的全资子公司。2010年，EAJ与日本经济产业省共同进行了“国际医疗交流”事业的前期调查，协助日本确立接收外国患者的国际医疗体系。EAJ也是早期开展赴日医疗协调服务的日本本土公司。</p>
          <p class="new-note">2011年，EAJ成为日本认证的医疗居留签证身份担保机关（登录管理番号B-001）</p>
          <p class="new-note">2012年，EAJ东京证券交易所JASDAQ上市</p>
          <p class="new-note new-line">2015年，EAJ获得“国际医疗协调机构”认证（认证书番号 MEJ-AMTAC-002）</p>
        </div>
        <div class="group-list">
          <div>
            <img :src="group1"
                 alt="">
            <p>服务团队</p>
          </div>
          <div>
            <img :src="group2"
                 alt="">
            <p>客户面对面咨询</p>
          </div>
          <div>
            <img :src="group3"
                 alt="">
            <p>远程视频咨询</p>
          </div>
        </div>
        <div class="group-list icon-btngroup">
          <router-link :to="item.path"
                       v-for="(item, index) in urlList"
                       :key="index" target="_blank">
            <img :src="item.iconUrl"
                 alt=""
                 class="icon">
            <p>
              <span class="text">{{item.name}}</span>
              <span>
                <img src="../assets/images/icon/right.png"
                     alt="">
              </span>
            </p>
          </router-link>
        </div>
        <h4 class="rescue-title" id="wmjys">威马捷优势</h4>
        <div class="index-advance">
          <div>
            <h4>
              <span>优势1</span>庞大的医院网络</h4>
            <p class="content_class">威马捷与日本、德国、意大利、新加坡、美国和香港等国家和地区的医疗机构建立了长期密切的合作关系。仅日本，已经向超过100家的医疗机构介绍了客户，提供检查、治疗、第二诊疗意见、体检、抗衰老等医疗咨询、医疗协调等服务。</p>
          </div>
          <div>
            <h4>
              <span>优势2</span>从出国前到出国后的一站式服务</h4>
            <p>向客户提供医疗机构和治疗信息、协助取得医疗签证、安排接送机、代订酒店、派遣医疗翻译、医疗费代付等在海外接受治疗等所需的一站式服务。回国后可根据客户需求安排定期复查。</p>
          </div>
          <div>
            <h4>
              <span>优势3</span>专业的医疗协调员</h4>
            <p>所有威马捷的医疗协调员，都是通过内部专业培训和严格考核后上岗。可根据客户需求，结合内部常年累积的大量数据和医院规定，向客户提供恰当的医疗信息和建议，使客户在短时间内找到适合的资源。</p>
          </div>
          <div>
            <h4>
              <span>优势4</span>紧急转运服务</h4>
            <p>客户在海外就医期间，全程提供24小时紧急联络服务。万一客户病情出现恶化等，需要紧急转运时，可提供由医生和护士组成的紧急救援团，进行包机等航空转运。</p>
          </div>
        </div>
        <h4 class="rescue-title"
            id="two">服务项目 </h4>
        <img :src="service_item"
             alt=""
             class="imgs">
        <h4 class="rescue-title"
            id="three">服务内容 </h4>
        <img :src="service_content"
             alt=""
             class="imgs"
             style="margin:73px auto 108px">
        <!--<h4 class="rescue-title"
            id="four">EAJ资格认证 </h4>
        <div class="eaj-list">
          <div class="eaj-main">
            <h5>医疗居留签证身份担保机构（登记管理番号 B-001）</h5>
            <div class="eaj-item">
              <a :href="eaj1">
                <img :src="eaj1"
                     alt="">
              </a>
              <div class="eaj-text">
                <p>医疗居留签证，是签发给以在日本接受治疗（包括精密体检等）为目的赴日的外国人患者以及同行人员的签证。申请医疗居留签证需要由日本外务省备案的身份担保机构提供身份担保。</p>
                <p>2011年日本外务省创设医疗居留签证制度之后，EAJ于同年2月取得医疗居留签证身份担保机构资质。</p>
                <p>日本外务省官网医疗居留签证身份担保机构一览</p>
                <a href="https://www.mofa.go.jp/j_info/visit/visa/medical_stay2.html">https://www.mofa.go.jp/j_info/visit/visa/medical_stay2.html</a>
              </div>
            </div>
          </div>
          <div class="eaj-main">
            <h5>国际医疗协调机构认证（认证书番号 MEJ-AMTAC-002）</h5>
            <div class="eaj-item">
              <a :href="eaj2">
                <img :src="eaj2"
                     alt="">
              </a>
              <div class="eaj-text">
                <p>国际医疗协调机构认证是日本政府健康与医疗战略推进本部下设的推广国际医疗专案组，为了培育海外患者在日本安心接受医疗服务而提供高质量支援服务的国际医疗协调机构，并使其在海内外提高认知度为目的而确立的认证制度。</p>
                <p>2015年6月确立国际医疗协调机构认证制度后，EAJ于同年9月通过了认证审查，并取得认证。</p>
                <p>一般社团法人Medical Excellence JAPAN官网国际医疗协调机构认证</p>
                <a href="https://medicalexcellencejapan.org/cn/business/certification/amtac/">https://medicalexcellencejapan.org/cn/business/certification/amtac/</a>
              </div>
            </div>
          </div>
          <div class="eaj-main">
            <h5>旅游业登录通知书（东京都知事登录旅游行业第3-5955号）</h5>
            <div class="eaj-item">
              <a :href="eaj3">
                <img :src="eaj3"
                     alt="">
              </a>
              <div class="eaj-text">
                <p>为了给海外客户提供更好的服务，EAJ于2012年取得旅游业从业资格。</p>
              </div>
            </div>
          </div>
        </div>-->
      </div>
      <div class="main">

        <h5 class="secure-title1 title01"
            id="hospital">合作医院
          <router-link class="ccc" to="/hospitalList/fwlx/0" target="_blank">更多 &gt;</router-link>
        </h5>
        <div class="secure-hospital">
          <router-link v-for="(hos, index) in hospitals"
                       :to="'/hospitalInfo/' + hos.id"
                       target="_blank"
                       :key="index">
            <img class="hospital-img"
                 :src="baseURL + hos.hospital_img"
                 alt="">
            <div class="hospital-content">
              <h6 class="hospital-name"
                  v-html="hos.name"></h6>
              <p class="hospital-info">{{hos.easy_brief}}</p>
            </div>
          </router-link>
        </div>
        <h5 class="secure-title1 title02"
            id="cases"
            style="padding-top:70px;">服务案例
          <router-link class="ccc" to="/successCase/0" target="_blank">更多 &gt;</router-link>
        </h5>
        <div class="fw-bg">
          <div class="medicine-case"
               v-for="(c,index) in cases"
               :key="index">
            <router-link target="_blank" :to="{name: 'successCaseDetail',params:{ id: c.id} }">
              <div class="case-info">
                <h5>{{c.title}}</h5>
                <p class="case-ill">
                  <span>疾病：{{c.disease_name}} </span>
                  <span class="b">{{c.alias}}<br/> {{c.age}} 岁</span>
                </p>
                <!-- <p class="case-topic">摘要： {{c.desc}}</p> -->
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import group1 from '@/assets/images/medicine/index_group1.png'
import group2 from "@/assets/images/medicine/index_group2.png"
import group3 from "@/assets/images/medicine/index_group3.png"
import service_item from "@/assets/images/medicine/service_item.png"
import service_content from "@/assets/images/medicine/service_content.png"
import eaj1 from "@/assets/images/medicine/EAJ1.png"
import eaj2 from "@/assets/images/medicine/EAJ2.png"
import eaj3 from "@/assets/images/medicine/EAJ3.png"
import leftSideBar from "@/components/LeftSideTitleBar.vue"
import SideBar from "@/components/SideBar"
import * as apis from '@/api/hospital'
import * as cases from '@/api/success'
import { baseURL } from "@/api/axios"
export default {
  data () {
    return {
      baseURL,
      group1,
      group2,
      group3,
      service_item,
      service_content,
      eaj1,
      eaj2,
      eaj3,
      countries: [],
      cases: [],
      hospitals: [],
      anchor: [
        { title: '为什么找威马捷', id: 'one' },
        { title: '威马捷优势', id: 'wmjys' },
        { title: '服务项目', id: 'two' },
        { title: '服务内容', id: 'three' },
        // { title: '资格认证', id: 'four' },
        { title: '合作医院', id: 'hospital' },
        { title: '服务案例', id: 'cases' },
      ],
      urlList: [
        {
          iconUrl: require('../assets/images/icon/icon-01.png'),
          name: '精密体检',
          path: '/internationalBodyCheck'
        },
        {
          iconUrl: require('../assets/images/icon/icon-02.png'),
          name: '先进医疗',
          path: '/internationalAdvanced'
        },
        {
          iconUrl: require('../assets/images/icon/icon-03.png'),
          name: '合作医院',
          path: '/hospitalList/fwlx/0'
        },
        {
          iconUrl: require('../assets/images/icon/icon-04.png'),
          name: '医疗签证',
          path: '/internationalMedicalVisa'
        },
      ]
    }
  },
  components: {
    leftSideBar,
    SideBar
  },
  mounted () {
    this.getHospitalList();
    this.getSuccessList();
  },
  methods: {
    async getHospitalList () {
      try {
        let data = {
          hospital_type_id: 1,
          //出国看病 3
          state_id: undefined,
          area_id: undefined,
          department_id: undefined,
          disease_id: [],
          keyword: undefined,
          page: 1
        }
        let res = await apis.getAllHospitalList(data);
        if (res.code == 200) {
          let rs = res.data.data.map(item => {
            return {
              ...item,
              info: this.getSimpleText(item.easy_brief)
            }
          });
          if (rs.length > 6) {
            this.hospitals = rs.slice(0, 6);
          } else {
            this.hospitals = rs;
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getSuccessList () {
      try {
        let data = {
          page: 1,
          disease_id: 0,
          type_id: 0,
          id: 0
        }
        let res = await cases.getSuccessCaseList(data);
        if (res.code == 200) {
          this.cases = res.data.data.slice(0, 3);
        }
      } catch (e) {
        console.log(e)
      }
    },
    getSimpleText (html) {
      var re1 = new RegExp("<.+?>", "g");//匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      var msg = html.replace(re1, '');//执行替换成空字符
      return msg;
    },
    setDoctorName (name) {
      if (name) {
        return name.replace(/\n/g, "<br/>");
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
.inner-main {
  width: 930px;
  margin: 0 auto;
}
.inner-img {
  width: 100%;
}
.new-note {
  font-size: 16px;
  line-height: 32px;
  text-indent: 32px;
  color: #333130;
}
.new-line {
  margin-bottom: 38px;
}
.bg-white {
  background: #fff;
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
}
.secure-block {
  width: 980px;
  border: 1px solid #dcdcdc;
  background: #fff;
  padding: 26px;
  margin: 20px auto 124px;
}
.secure-title1 {
  font-size: 24px;
  color: #000;
  line-height: 32px;
  // padding: 5px 0 5px 40px;
  // height: 32px;
  padding-left: 40px;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 28px auto;
  margin-bottom: 40px;
  a {
    float: right;
    color: #333130;
  }
}
.title01 {
  // background-image: url("../assets/images/home/yy-icon.png");
  // background: url('../assets/images/home/hzyy-icon.png') no-repeat left center;
  background: url('../assets/images/home/hzyy-icon.png') no-repeat 0 107px;
  background-size: 28px 28px;
  a {
    font-size: 24px;
  }
}
.title02 {
  background-image: url('../assets/images/home/fwal-icon.png');
  background-position: 0 70px;
  background-size: 28px 28px;
}

.imgs {
  display: block;
  margin: 59px auto 100px;
}
.ccc:hover {
  color: #2d8cf0!important;
}

.secure-hospital {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 32px;
  a {
    display: block;
    width: 302px;
    min-height: 396px;
    background: #fff;
    border: 1px solid #dcdcdc;
    margin-bottom: 32px;
    // margin-right: 20px;
    transition: 0.5s all;
    margin-right: 37px;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
    &:hover {
      transform: scale(1.05);
      box-shadow: 0 0 10px #d1d1d1;
    }
  }
  .hospital-img {
    width: 300px;
    height: 220px;
    margin: 0 !important;
  }
  .hospital-content {
    padding: 20px 24px 35px;
    height: 200px;
    .hospital-name {
      font-size: 20px;
      color: #333130;
      line-height: 26px;
      margin-bottom: 15px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .hospital-info {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      color: #9b9898;
      font-size: 16px;
      line-height: 32px;
    }
  }
}

.medicine-case:last-child {
  margin-bottom: 133px;
}

.fw-bg {
  background: url(../assets/images/fw-bg.png) no-repeat left top #fff;
}

.medicine-case {
  width: 100%;
  border: 1px solid #ececec;
  padding: 34px 54px 34px 27px;
  .case-img {
    width: 237px;
    height: 177px;
    margin-right: 34px;
  }
  .case-info {
    display: block;
    // width: 610px;
    // vertical-align: top;
    h5 {
      font-size: 20px;
      color: #373737;
      font-weight: normal;
      line-height: 26px;
      margin-bottom: 10px;
      p {
        display: inline-block;
        font-size: 16px;
      }
    }
    .case-ill {
      font-size: 18px;
      line-height: 22px;
      color: #cf1300;
      font-weight: bold;
      span {
        width: 200px;
        display: inline-block;
      }
      .b {
        margin-left: 180px;
        font-weight: 400;
        color: #373737;
      }
      // background: url("../assets/images/medicine/line.jpg") repeat-x bottom;
      // padding-bottom: 16px;
      // margin-bottom: 18px;
    }
    .case-topic {
      font-size: 14px;
      color: #585858;
      line-height: 30px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
  }
}

/*新样式 */
.group-list {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  div {
    img {
      width: 280px;
      margin-bottom: 18px;
    }
    p {
      font-size: 16px;
      text-align: center;
      margin-bottom: 99px;
    }
  }
  a {
    display: inline-block;
    width: 208px;
    height: 208px;
    color: #333130;
    font-size: 20px;
    text-align: center;
    border: 1px solid #d1d1d1;
    transition: 0.5s all;
    margin-bottom: 100px;
    .icon {
      margin-top: 44px;
      width: 70px;
      height: 70px;
      border-radius: 6px;
      box-shadow: 0 0 10px #d1d1d1;
    }
    p {
      margin-top: 30px;
      transition: 0.5s all;
      span {
        margin: 0 5px;
        transition: 0.5s all;
      }
    }
    &:hover {
      background-color: #f3f3f3;
      .text {
        text-decoration: underline;
        color: #999999;
      }
      span {
        margin: 0 8px;
      }
    }
  }
}
.index-advance {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-around;
  flex-wrap: wrap;
  div {
    width: 440px;
    height: 230px;
    margin-bottom: 20px;
    border: 1px solid #e9ebf4;
    h4 {
      height: 50px;
      background: #e9ebf4;
      color: #333;
      font-size: 20px;
      font-weight: 400;
      line-height: 50px;
      span {
        display: inline-block;
        width: 84px;
        color: #fff;
        background: #ae1e10;
        text-align: center;
        margin-right: 20px;
      }
    }
    p {
      font-size: 16px;
      line-height: 32px;
      box-sizing: border-box;
      padding: 19px 14px 17px 10px;
    }
  }
}
#two {
  padding-top: 42px;
}
.eaj-list {
  .eaj-main {
    margin-bottom: 40px;
    width: 100%;
    border: 1px solid #e9ebf4;
    .eaj-item {
      display: flex;
      box-sizing: border-box;
      padding: 20px 30px;
      .eaj-text {
        margin-bottom: 20px;
        flex: 1;
        margin-left: 18px;
        p {
          font-size: 16px;
          color: #333130;
          line-height: 32px;
        }
        a {
          font-size: 16px;
          color: #333;
          line-height: 20px;
          text-decoration: underline;
          word-break: break-all;
        }
      }
      img {
        width: 140px;
        height: 190px;
        transition: 0.5s all;
        cursor: pointer;
        &:hover {
          transform: scale(2);
          body {
            background-color: #000;
          }
        }
      }
    }
    h5 {
      font-size: 20px;
      color: #333;
      line-height: 50px;
      background-color: #e9ebf4;
      padding-left: 34px;
      font-weight: bold;
    }
  }
  .eaj-main:last-child {
    margin-bottom: 0;
  }
}
</style>
<style>
.hospital-name {
  font-size: 20px;
  color: #333130;
  line-height: 26px;
  margin-bottom: 15px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.content_class {
  text-align: justify;
  -ms-text-align-last: justify;
  -moz-text-align-last: justify;
  text-align-last: start;
  word-break: break-all;
  text-justify: distribute;
}
::v-deep .ivu-anchor-link {
  line-height: 1.1!important;
}
  ::v-deep .ivu-anchor-link-title {
    line-height: 1.1!important;
  }
</style>

